import { render } from "./updateUserDataFirstLoginMutation.vue?vue&type=template&id=b56f3414"
import script from "./updateUserDataFirstLoginMutation.vue?vue&type=script&lang=js"
export * from "./updateUserDataFirstLoginMutation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__